module.exports = __webpack_public_path__ + "static/media/delete.fb562bac.svg";